import { render } from "./FormGroupInput.vue?vue&type=template&id=63e410c8"
import script from "./FormGroupInput.vue?vue&type=script&lang=js"
export * from "./FormGroupInput.vue?vue&type=script&lang=js"

import exportComponent from "/Users/aml/Projects/dashboardcopy2/fnbxv21-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__